<template>
  <div class="ps-2">
    <PageSection :title="t('reservations.pastBookings')">
      <section class="row d-flex">
        <PastBooking
          v-for="booking in props.bookings"
          :booking="booking"
          :key="`${booking.liheId}-${booking.departureDate}`"
        />
      </section>
    </PageSection>
  </div>
</template>

<script setup lang="ts">
  import { defineProps } from 'vue'

  // Types
  import { BookingSummary } from '@/services/BookingService.interface'

  // Components
  import PastBooking from './PastBooking.vue'
  import PageSection from '../UI/PageSection.vue'

  // Translations
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()

  interface Props {
    bookings: BookingSummary[]
  }

  const props = defineProps<Props>()
</script>

<style scoped></style>
